import React, {Component} from "react";
import { FormattedMessage } from "react-intl";
import { Button, Result } from "antd";
import Nprogress from "nprogress";
import ReactPlaceholder from "react-placeholder";
import "nprogress/nprogress.css";

import "react-placeholder/lib/reactPlaceholder.css";
import CircularProgress from "components/CircularProgress";
import { isChunkLoadError, reloadOnce } from "./appVersion";

export default function asyncComponent(importComponent) {
  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null,
        error: null
      };
    }

    componentWillMount() {
      Nprogress.start();
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    async componentDidMount() {
      this.mounted = true;
      let Component;
      try {
        ({default: Component} = await importComponent());
      } catch (error) {
        Nprogress.done();
        // The chunk is from a previous deploy: load the new build instead of
        // spinning forever.
        if (isChunkLoadError(error) && reloadOnce()) return;
        // Say so instead of an endless loader (blank where the loader is hidden).
        console.error('Page failed to load', error);
        if (this.mounted) this.setState({error});
        return;
      }
      Nprogress.done();
      if (this.mounted) {
        // Only the class is kept: the element is built in render() so match / location props stay current.
        this.setState({component: Component});
      }
    }

    render() {
      if (this.state.error) {
        return (
          <Result
            status="warning"
            title={<FormattedMessage id="app.pageLoadFailed" defaultMessage="This page could not be loaded"/>}
            subTitle={String(this.state.error?.message || this.state.error).slice(0, 300)}
            extra={<Button type="primary" onClick={() => window.location.reload()}>
              <FormattedMessage id="app.tryAgain" defaultMessage="Try again"/>
            </Button>}
          />
        );
      }
      const Loaded = this.state.component;
      const content = Loaded ? <Loaded {...this.props} /> : <CircularProgress/>;
      return (
        <ReactPlaceholder type="text" rows={7} ready={content !== null}>
          {content}
        </ReactPlaceholder>
      );
    }
  }

  return AsyncFunc;
}
